import BaseAnimationAction from "./baseAnimationAction";

class PlayAnimation extends BaseAnimationAction {

    constructor(props) {
        super(props);
    }

    async execute({training}) {
        const animation = training.resources[this.animationId];
        const branchId = this.getBranchId(training);

        AnimationPlayer.stopConflictingMeshAnimations(this.meshType, branchId, true, animation.id);

        AnimationPlayer.play(animation, this.meshType, branchId, this.loop);
    }

    async stop(training) {
        const animation = training.resources[this.animationId];
        const branchId = this.getBranchId(training);

        console.log("Stopping Animation: " + (animation ? animation.name : this.animationId));
        AnimationPlayer.stop(this.meshType, branchId);
    }
}

export default PlayAnimation;